import {UI} from "../../../../../stem-core/ui/UIBase";

import {BasePanelPage, BasePanelPageStyle} from "../../../PanelPage";
import {Messages} from "../../../../Messages";
import {dismissFlowSuccess} from "../../../../widget/misc/WidgetUtils";
import {HappyFaceIcon} from "../../../../../core/ui/SVGElements.jsx";
import {styleRule, styleRuleInherit} from "../../../../../stem-core/decorators/Style";
import {SubscriptionCoveragePerk} from "./components/CoverageDescriptionElements";
import {registerStyle} from "../../../../../stem-core/ui/style/Theme";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {TNR_ALIAS} from "../../../../../blink-sdk/Constants";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {Flow} from "../../../flows/Flow.js";
import {iFrameState} from "../../../../services/IFrameState";
import {PromptManageAccountButton} from "../../../panel-elements/LoginFooter.jsx";
import {BlinkButton} from "../../../../../core/ui/Button.jsx";
import {DonationOffer} from "../../../../../client/state/DonationOfferStore.js";
import {iFrameUserDataService} from "../../../../services/IFrameUserDataService.js";


export class SubscribeSuccessPanelStyle extends BasePanelPageStyle {
    @styleRuleInherit
    title = {
        textAlign: "center",
        ...this.themeProps.MERCHANT_TITLE_STYLE,
    };

    @styleRule
    icon = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    };

    @styleRule
    message = {
        color: this.themeProps.TEXT_SECONDARY_COLOR,
    };
}

@registerStyle(SubscribeSuccessPanelStyle)
export class SubscribeSuccessPanel extends BasePanelPage {
    getGuidelines() {
        if (iFrameState.forceHideWallet) {
            return []
        }

        return [
            <SubscriptionCoveragePerk text={Messages.subscribeThankYouGuideline1}/>,
            <SubscriptionCoveragePerk text={Messages.subscribeThankYouGuideline2}/>,
        ]
    }

    renderCrossSellNudge() {
        if (!iFrameState.iframeParams.onSuccessCrossSell) {
            return null;
        }

        // TODO @branch this should only be shown when the option is enabled
        const donationOffer = DonationOffer.getAvailable()[0];
        if (!donationOffer) {
            return null;
        }

        const latestDonation = iFrameUserDataService.getLatestDonation();
        if (latestDonation) {
            const timeSinceLastDonation = Date.now() - (new Date(latestDonation.createdAt)).getTime();
            if (timeSinceLastDonation < 60 * 24 * 60 * 60 * 1000) {
                // If they donated within the last 60 days, don't ask for donations
                return null;
            }
        }

        return null;
    }

    render() {
        const {styleSheet} = this;
        const offer = Flow.subscriptionPlan.selectedValue;
        let textElements;

        if (iFrameMerchantService.isMerchant(TNR_ALIAS)) {
            textElements = [
                <div testId="subscribeModalThankYouTitle" className={styleSheet.title}>
                    {Messages.subscribeThankYouTitle}
                </div>,
                <MessageElement className={styleSheet.message} message={Messages.subscribeThankYouText(offer.coverage.name)}/>,
                <div className={styleSheet.message}>{Messages.tnrSubscribeSuccess}</div>,
                <MessageElement className={styleSheet.message}
                                message={Messages.subscribeAndEditSuccess(iFrameMerchantService.getMerchant().getName())} />
            ];
        } else {
            textElements = [
                <HappyFaceIcon className={styleSheet.icon} size={72} color={styleSheet.themeProps.TEXT_SECONDARY_COLOR}/>,
                <div testId="subscribeModalThankYouTitle" className={styleSheet.title}>
                    {Messages.subscribeThankYouTitle}
                </div>,
                <div className={styleSheet.message}>{Messages.subscribeThankYouText(offer.coverage.name)}</div>,
            ]
        }

        return [
            textElements,
            this.renderCrossSellNudge() || [
                this.getGuidelines(),
                <BlinkButton onClick={dismissFlowSuccess} className={styleSheet.actionButton}>
                    {Messages.ok}
                </BlinkButton>,
            ],
            !iFrameMerchantService.isMerchant(TNR_ALIAS) && <PromptManageAccountButton className={styleSheet.backButton}/>,
        ];
    }
}
